import { render } from "./InviteColumn.vue?vue&type=template&id=9299bb46&scoped=true"
const script = {}

import "./InviteColumn.vue?vue&type=style&index=0&id=9299bb46&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9299bb46"]])

export default __exports__